<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BContainer
      fluid
    >
      <BRow>

        <BCol
          cols="12"
          class="px-1"
        >
          <BFormGroup
            label="Search"
            label-for="filterVehicleSearch"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="filterVehicleSearch"
              v-model="tableVehicles.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          class="px-1 mb-2"
        >
          <BButton
            size="sm"
            type="button"
            variant="primary"
            @click.prevent="createVehicle"
          >
            Create Vehicle
          </BButton>
        </BCol>

      </BRow>

      <BRow
        class="mt-1"
      >
        <BCol
          cols="12"
          class="px-1"
        >
          <BTable
            ref="tableVehicles"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :items="tableProvider"
            :busy="tableVehicles.busy"
            :filter="tableVehicles.filter"
            :fields="tableVehicles.fields"
            :stacked="tableVehicles.stacked"
            :sort-by.sync="tableVehicles.sortBy"
            :sort-desc.sync="tableVehicles.sortDesc"
            :sort-direction="tableVehicles.sortDirection"
            :filter-included-fields="tableVehicles.filterOn"
            :current-page="tableVehicles.currentPage"
            :per-page="tableVehicles.perPage"
          >
            <template #cell(index)="{ index }">
              {{ tableRowNumber(tableVehicles, index) }}
            </template>

            <template #cell()="{ value }">
              <div class="text-md-nowrap">
                {{ value }}
              </div>
            </template>

            <template #cell(action)="{ item }">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <BButton
                  size="sm"
                  variant="primary"
                  @click.prevent="editVehicle(item)"
                >
                  Edit
                </BButton>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <BIcon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </BTable>
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <BFormSelect
            v-model="tableVehicles.perPage"
            :options="tableVehicles.pageOptions"
            :disabled="tableVehicles.busy"
            class="w-100 w-md-25"
            size="sm"
          />
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <BPagination
            v-model="tableVehicles.currentPage"
            :total-rows="tableVehicles.totalRows"
            :per-page="tableVehicles.perPage"
            :disabled="tableVehicles.busy"
            aria-controls="table"
            prev-text="Prev"
            next-text="Next"
            first-number
            last-number
            pills
          />
        </BCol>
      </BRow>
    </BContainer>

    <BModal
      id="modalVehicle"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      :title="ModalVehicleTitle"
      aria-hidden="false"
    >
      <ValidationObserver
        ref="formVehicle"
      >
        <form
          role="form"
          novalidateVehicle
          @submit.prevent
        >
          <BRow>
            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="vehicle plate"
                vid="vehicle_plate"
                rules="required|max:30"
              >
                <BFormGroup
                  label="Vehicle Plate"
                  label-for="vehicle_plate"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="vehicle_plate"
                    v-model="vehicle.vehicle_plate"
                    type="text"
                    autocomplete="off"
                    maxlength="30"
                    placeholder="enter vehicle plate here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="vehicle name"
                vid="vehicle_name"
                rules="required|max:100"
              >
                <BFormGroup
                  label="Vehicle Name"
                  label-for="vehicle_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="vehicle_name"
                    v-model="vehicle.vehicle_name"
                    type="text"
                    autocomplete="off"
                    maxlength="100"
                    placeholder="enter vehicle name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              v-if="state.editing"
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="is_active"
                  v-model="vehicle.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>
          </BRow>

        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <BButton
          variant="primary"
          size="sm"
          tabindex="-1"
          :disabled="state.busy"
          @click.prevent="validateVehicle"
        >
          {{ state.editing ? 'Update' : 'Create' }} Vehicle
        </BButton>
        <BButton
          variant="outline-dark"
          size="sm"
          tabindex="-1"
          :disabled="state.busy"
          @click.prevent="$event => {
            $event.target.blur()
            cancel()
          }"
        >
          Discard
        </BButton>
      </template>

    </BModal>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import QUERY from 'lodash'
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import { SLOVehicle } from '@/services/lo'

export default {
  name: 'VLogisticsOfficerVehicles',

  middleware: [
    'auth',
    'lo'
  ],

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Vehicles'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      vehicle: {
        id: '',
        vehicle_plate: '',
        vehicle_name: '',
        active: 1
      },
      tableVehicles: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 6, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'vehicle_plate', class: 'min-w-150px' },
          { mobile: 3, key: 'vehicle_name', class: 'min-w-200px' },
          { mobile: 4, key: 'active', class: 'text-center', formatter: this.yesOrNo },
          { mobile: 5, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalVehicleTitle () {
      return this.state.editing ? 'Edit Vehicle' : 'Add Vehicle'
    },

    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableVehicles.busy = true
      return await SLOVehicle.get({
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search
      }).then(({ data }) => {
        this.tableVehicles.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        this.tableVehicles.totalRows = 0
        return []
      }).finally(() => {
        this.tableVehicles.busy = false
      })
    },

    createVehicle () {
      this.state.editing = false
      this.vehicle.id = ''
      this.vehicle.vehicle_plate = ''
      this.vehicle.vehicle_name = ''
      this.vehicle.active = 1
      this.$bvModal.show('modalVehicle')
    },

    editVehicle (vehicle) {
      this.state.editing = true
      this.vehicle.id = vehicle.id
      this.vehicle.vehicle_plate = vehicle.vehicle_plate
      this.vehicle.vehicle_name = vehicle.vehicle_name
      this.vehicle.active = vehicle.active
      this.$bvModal.show('modalVehicle')
    },

    async validateVehicle () {
      await this.$refs.formVehicle.validate().then(
        async validVehicle => {
          if (!validVehicle) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: () => {
              if (this.state.editing) {
                return '<h6>Update Vehicle?</h6>'
              }
              return '<h6>Create Vehicle?</h6>'
            },
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.updateVehicle()
              }
              return this.submitVehicle()
            }
          })
        }
      )
    },

    async submitVehicle () {
      return await SLOVehicle.post(this.vehicle).then(
        ({ data: { message } }) => {
          this.$bvModal.hide('modalVehicle')
          this.swalSuccess(message).then(() => {
            this.$refs.tableVehicles.refresh()
          })
        }
      ).catch(({ message }) => {
        this.$refs.formVehicle.setErrors(message)
      }).finally(() => {
        this.state.busy = false
      })
    },

    async updateVehicle () {
      return await SLOVehicle.put(this.vehicle).then(
        ({ data: { message, vehicle } }) => {
          this.$bvModal.hide('modalVehicle')
          this.swalSuccess(message).then(() => {
            const tableVehiclesRow = QUERY.find(this.$refs.tableVehicles.localItems, {
              id: Number(vehicle.id)
            })
            if (tableVehiclesRow) {
              tableVehiclesRow.vehicle_name = vehicle.vehicle_name
              tableVehiclesRow.vehicle_plate = vehicle.vehicle_plate
              tableVehiclesRow.active = vehicle.active
              tableVehiclesRow.updated_at = vehicle.updated_at
            }
          })
        }
      ).catch(({ message }) => {
        this.$refs.formVehicle.setErrors(message)
      }).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
